export default class ConsentLinks {
  constructor() {
    const root = document.querySelector('.tournament__register[data-privacy]');
    const label = root?.querySelector('.um-field-checkbox-option');

    if (!label) {
      return;
    }

    const links = {
      'Privacy Policy': root.dataset.privacy,
      Regolamento: root.dataset.rules,
    };

    const text = label.textContent;
    const pattern = new RegExp(`(${Object.keys(links).join('|')})`, 'gi');
    const fragment = document.createDocumentFragment();

    text.split(pattern).forEach((part) => {
      const href = links[Object.keys(links).find((key) => key.toLowerCase() === part.toLowerCase())];

      if (!href) {
        fragment.append(part);
        return;
      }

      const a = document.createElement('a');
      a.href = href;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = part;
      fragment.append(a);
    });

    label.replaceChildren(fragment);
  }

  destroy() {}
}
